export default {
  translation: {
    common: {
      emailOrUsername: 'Email hoặc tên đăng nhập',
      invalidEmailOrUsername: 'Sai email hoặc tên đăng nhập',
      invalidPassword: 'Sai mật khẩu',
      logInToWowScada: 'Đăng nhập vào Sei-Power',
      noInternetConnection: 'Không có kết nối mạng',
      pageNotFound_title: 'Không tìm thấy trang',
      password: 'Mật khẩu',
      factoryManagement: 'Hệ Thống Giám Sát Và Quản Lý Năng Lượng',
      serverConnectionFailed: 'Không có kết nối server',
      unknownError: 'Lỗi! Hãy thử lại sau',
    },

    action: {
      logIn: 'Đăng nhập',
    },
  },
};
